/* 南方洋行 · 墨と光 的动效（渐进增强，没有它页面照常可用）
   - 进场：[data-reveal] 进入视口时加 .is-in（隐藏只在 html.nh-motion 时生效，见 layout/theme.liquid）
   - 声明逐行：[data-lines] 按 <br> 拆成逐行升起
   - 商品卡：唱片上的高光、封套上的光带跟着指针角度走（写 CSS 变量 --a / --sa）
   - 今月の一枚：聚光灯跟着指针，商品图随指针倾斜、反光转向
   - アーティスト：悬停时封面跟着指针漂浮
   - 「View」指针：只在 [data-cur="view"] 上出现
   - 柱：宽屏左侧的竖排小标题，显示当前区块的 data-hashira
   - Page top：[data-nh-top]
   在主题编辑器里改区块后（shopify:section:load）会对新区块重新初始化。
   来源：design/v2/parts/03-script.html */
(() => {
  window.__nhMotion = true;
  const root = document.documentElement;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* 进场 */
  let io = null;
  const reveal = scope => {
    const els = scope.querySelectorAll('[data-reveal]:not(.is-in), [data-lines].is-split:not(.is-in)');
    if (!root.classList.contains('nh-motion') || !('IntersectionObserver' in window)) {
      els.forEach(el => el.classList.add('is-in'));
      return;
    }
    io = io || new IntersectionObserver(entries => {
      entries.forEach(en => {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(el => io.observe(el));
  };

  /* 声明逐行（文字已由 Liquid 转义，这里只按 <br> 拆开） */
  const splitLines = scope => {
    scope.querySelectorAll('[data-lines]:not(.is-split)').forEach(el => {
      const parts = el.innerHTML.split(/<br\s*\/?>/i).map(s => s.trim()).filter(Boolean);
      el.innerHTML = parts.map((s, i) => `<span class="ln"><span style="--i:${i}">${s}</span></span>`).join('');
      el.classList.add('is-split');
    });
  };

  /* 商品卡：光随指针 */
  const angleTo = (el, e) => {
    const r = el.getBoundingClientRect();
    return Math.atan2(e.clientY - (r.top + r.height / 2), e.clientX - (r.left + r.width / 2)) * 180 / Math.PI;
  };
  if (!reduce) {
    document.addEventListener('pointermove', e => {
      const art = e.target.closest && e.target.closest('.rc__art');
      if (!art) return;
      const a = angleTo(art, e) + 90;
      art.style.setProperty('--a', a + 'deg');
      art.style.setProperty('--sa', a + 'deg');
    }, { passive: true });
  }

  /* 今月の一枚：聚光灯 + 倾斜 */
  const bindFeature = scope => {
    if (!fine || reduce) return;
    scope.querySelectorAll('[data-feat]').forEach(feat => {
      if (feat.__nh) return;
      feat.__nh = true;
      const cover = feat.querySelector('[data-feat-cover]');
      feat.addEventListener('pointermove', e => {
        const r = feat.getBoundingClientRect();
        feat.style.setProperty('--sx', ((e.clientX - r.left) / r.width * 100).toFixed(2) + '%');
        feat.style.setProperty('--sy', ((e.clientY - r.top) / r.height * 100).toFixed(2) + '%');
        if (!cover) return;
        const c = cover.getBoundingClientRect();
        const dx = (e.clientX - (c.left + c.width / 2)) / c.width;
        const dy = (e.clientY - (c.top + c.height / 2)) / c.height;
        const k = Math.min(1, 1.4 / (1 + Math.hypot(dx, dy)));
        cover.style.setProperty('--ry', (dx * 10 * k).toFixed(2) + 'deg');
        cover.style.setProperty('--rx', (-dy * 8 * k).toFixed(2) + 'deg');
        cover.style.setProperty('--sa', (Math.atan2(dy, dx) * 180 / Math.PI + 90).toFixed(1) + 'deg');
      }, { passive: true });
      feat.addEventListener('pointerleave', () => {
        if (!cover) return;
        cover.style.setProperty('--ry', '0deg');
        cover.style.setProperty('--rx', '0deg');
      });
    });
  };

  /* アーティスト：悬浮封面 */
  const bindArtists = scope => {
    if (!fine || reduce) return;
    scope.querySelectorAll('[data-ar]').forEach(list => {
      if (list.__nh) return;
      list.__nh = true;
      const float = list.closest('section') && list.closest('section').querySelector('[data-ar-float]');
      if (!float) return;
      /* 10/29：一行带 data-imgs（这一类的几件，最多 4 张，置顶的在前）时错开排成一手牌；只有一张时照旧 */
      const pics = [0, 1, 2, 3].map(i => {
        const im = new Image(); im.alt = ''; im.decoding = 'async'; im.style.setProperty('--i', i); float.appendChild(im); return im;
      });
      let showing = '', fw = 0, fh = 0;
      const show = a => {
        const key = a.dataset.imgs || a.dataset.img;
        if (key === showing) return;
        showing = key;
        const urls = (a.dataset.imgs || a.dataset.img).split('|').slice(0, 4);
        pics.forEach((im, i) => {
          im.hidden = i >= urls.length;
          if (i < urls.length && im.getAttribute('src') !== urls[i]) im.src = urls[i];
        });
        float.classList.toggle('is-multi', urls.length > 1);
        float.style.setProperty('--nimg', urls.length);
        float.dataset.n = urls.length;
        fw = float.offsetWidth; fh = float.offsetHeight;
      };
      let fx = 0, fy = 0, tx = 0, ty = 0, raf = 0, fresh = true;
      const loop = () => {
        fx += (tx - fx) * 0.14;
        fy += (ty - fy) * 0.14;
        float.style.setProperty('--fx', fx.toFixed(1) + 'px');
        float.style.setProperty('--fy', fy.toFixed(1) + 'px');
        raf = Math.abs(tx - fx) + Math.abs(ty - fy) > 0.5 ? requestAnimationFrame(loop) : 0;
      };
      list.addEventListener('pointermove', e => {
        const a = e.target.closest('a[data-img]');
        if (a) show(a);
        float.classList.toggle('is-on', !!a);
        // 封面放在指针旁边 40px 外：右边放得下就放右边，否则放左边；再夹在窗口里（一手牌最宽，靠窗口边时不出界）
        const w = fw || 320, gap = 40;
        const right = innerWidth - e.clientX >= w + gap + 16 || innerWidth - e.clientX >= e.clientX;
        tx = e.clientX + (right ? 1 : -1) * (gap + w / 2);
        tx = Math.min(innerWidth - 16 - w / 2, Math.max(16 + w / 2, tx));
        const h = fh || w;
        ty = Math.min(innerHeight - 16 - h / 2, Math.max(16 + h / 2, e.clientY));
        if (fresh) { fx = tx; fy = ty; fresh = false; }
        if (!raf) raf = requestAnimationFrame(loop);
      }, { passive: true });
      const hide = () => { fresh = true; float.classList.remove('is-on'); };
      list.addEventListener('pointerleave', hide);
      // 封面是 fixed 定位：滚动时指针不动也会离开列表，这时收起，下次移动指针再出现
      addEventListener('scroll', () => { if (float.classList.contains('is-on')) hide(); }, { passive: true });
    });
  };

  /* 「View」指针 */
  const cur = document.querySelector('.nh-cur');
  if (cur && fine && !reduce) {
    root.classList.add('nh-cur-live');
    let shown = false;
    document.addEventListener('pointermove', e => {
      cur.style.setProperty('--cx', e.clientX + 'px');
      cur.style.setProperty('--cy', e.clientY + 'px');
      const on = !!(e.target.closest && e.target.closest('[data-cur="view"]'));
      if (on !== shown) { shown = on; cur.classList.toggle('is-on', on); }
    }, { passive: true });
    const hideCur = () => { shown = false; cur.classList.remove('is-on'); };
    document.documentElement.addEventListener('pointerleave', hideCur);
    addEventListener('scroll', () => { if (shown) hideCur(); }, { passive: true });
  }

  /* 柱 */
  const box = document.querySelector('.nh-hashira');
  const text = box && box.querySelector('[data-hashira-text]');
  if (text && 'IntersectionObserver' in window) {
    const base = text.textContent;
    const visible = new Set();
    let want = base, timer = 0;
    const set = t => {
      want = t;
      if (timer || text.textContent === want) return;
      box.classList.add('is-swap');
      timer = setTimeout(() => { text.textContent = want; box.classList.remove('is-swap'); timer = 0; }, 200);
    };
    const hio = new IntersectionObserver(entries => {
      entries.forEach(en => (en.isIntersecting ? visible.add(en.target) : visible.delete(en.target)));
      const now = [...document.querySelectorAll('[data-hashira]')].find(s => visible.has(s));
      set(now ? now.dataset.hashira : base);
    }, { rootMargin: '-50% 0px -50% 0px' });
    const watch = scope => scope.querySelectorAll('[data-hashira]').forEach(s => hio.observe(s));
    watch(document);
    document.addEventListener('shopify:section:load', e => watch(e.target));
  }

  /* Page top */
  document.addEventListener('click', e => {
    const a = e.target.closest && e.target.closest('[data-nh-top]');
    if (!a) return;
    e.preventDefault();
    scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
  });

  const init = scope => {
    splitLines(scope);
    reveal(scope);
    bindFeature(scope);
    bindArtists(scope);
  };
  init(document);
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
